(angular => {
  "use strict";

  angular.module("EventHotel").controller("EventHotel.IndexCtrl", [
    "$scope",
    "Loader",
    "EventService",
    "AuthService",
    "EventHotelService",
    IndexCtrl
  ]);

  function IndexCtrl($scope, loader, eventService, authService, eventHotelService) {
    this.user = authService.getTokenData();
    loader.add(eventService.current(true).then(event => {
      this.event = event;

      this.add = $event => {
        $scope.$emit('change-header-tab-current', 0);
        $scope.$broadcast('add-hotel', $event);
      };

      this.export = () => {
        eventHotelService.exportList();
      };

    }));


  }
})(angular || {});
